'use client'

/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react'
import Image from 'next/image'
import RightArrow from '@public/images/icons/right-arrow.png'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { TAP_EVENT } from '@constants/enterpriseSegmentData'
import styles from './enterpriseCategory.module.scss'

const Index = ({ data }) => {
  const { theme, enterprise_products: enterpriseProducts, title, subtitle, category } = data?.data

  const reDirectWithUrl = (url: string) => {
    url && window.open(url)
  }

  return (
    <div id={category} className={`${styles.main} ${styles[`${theme}Theme`]}`}>
      <h2 className={`${styles.mainTitle} ${styles[`${theme}ThemeTitle`]}`}>{title}</h2>
      <h3 className={`${styles.mainSubtitle} ${styles[`${theme}ThemeSubtitle`]}`}>{subtitle}</h3>
      <div className={styles.productList}>
        {enterpriseProducts?.data?.map((product, index) => (
          <div key={index} className={`${styles.productCard} ${styles[product?.attributes?.cardType]}`}>
            <div
              className={`${styles.productCardHead}`}
              style={{
                backgroundImage:
                  product?.attributes?.headerImage?.data?.attributes?.url
                  ? `url(${product?.attributes?.headerImage?.data?.attributes?.url})`
                  : ''
              }}
            >
                {!product?.attributes?.headerImage?.data?.attributes?.url && (
                  <>
                    <div className={styles.tagline}>
                      <Image
                        src={product?.attributes?.taglineIconUrl?.data?.attributes?.url}
                        alt={`tagline-icon-${product?.attributes?.taglineDescription}`}
                        width={16}
                        height={16}
                        loading="lazy"
                      />
                      <div className={styles.taglineText}>{product?.attributes?.taglineDescription}</div>
                    </div>
                    <div className={styles.productCardHeadText}>{product?.attributes?.headerTitle}</div>
                  </>
                )}
              </div>
              <div className={`${styles.productCardContent} ${styles[product?.attributes?.cardType]}`}>
                {product?.attributes?.title && (
                  <div className={styles.productTitle}>
                    <div className={styles.productTitleIcon}>
                      <Image
                        src={product?.attributes?.titleIconUrl?.data?.attributes?.url}
                        alt={`title-icon-${product?.attributes?.title}`}
                        width={32}
                        height={32}
                        loading="lazy"
                      />
                    </div>
                    <div>{product?.attributes?.title}</div>
                  </div>
                )}
                {product?.attributes?.subtitle && (
                  <div className={styles.productSubtitle}>{product?.attributes?.subtitle}</div>
                )}
                {product?.attributes?.FeatureInfoCard?.map((feature, index) => (
                  <div key={index} className={`${styles.featureCard} ${styles[product?.attributes?.cardType]}`}>
                    <Image
                      src={feature?.featureIconUrl?.data?.attributes?.url}
                      alt={`title-icon-${product?.attributes?.title}`}
                      width={24}
                      height={24}
                      loading="lazy"
                    />
                    <div className={styles.featureDetails}>
                      <div className={styles.featureTitle}>{feature?.heading}</div>
                      <div className={styles.featureSubtitle}>{feature?.description}</div>
                    </div>
                  </div>
                ))}
                <div className={styles.partnerSection}>
                    {product?.attributes?.partnerImageList?.data?.length > 0 && (<p>TRUSTED BY</p>)}
                    {product?.attributes?.partnerImageList?.data?.map((src, index) => (
                      <img
                        src={src?.attributes?.url}
                        alt={`category-title-logo-${index}`}
                        height={20}
                        width="auto"
                        loading="lazy"
                        key={index}
                      />
                    ))}
                </div>
                {product?.attributes?.cardType === 'standard'
                  ? <div
                    className={styles.actionLink}
                    onClick={() => sendEnterpriseEvent({ action_name: product?.attributes?.actionText, action_type: TAP_EVENT.TAP_BTN, journey: product?.attributes?.title }).then(() => reDirectWithUrl(product?.attributes?.redirectUrl))}
                  >
                    <p>{product?.attributes?.actionText}</p>
                    <Image
                      src={RightArrow}
                      alt={`category-title-logo-${product?.attributes?.cardType}`}
                      width={14}
                      height={12}
                      loading="lazy"
                    />
                  </div>
                  : <div
                      className={styles.actionText}
                      onClick={() => sendEnterpriseEvent({ action_name: product?.attributes?.actionText, action_type: TAP_EVENT.TAP_BTN, journey: product?.attributes?.title }).then(() => reDirectWithUrl(product?.attributes?.redirectUrl))}
                    >
                      {product?.attributes?.actionText}
                    </div>
                }
              </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Index
